import { generateTransId } from './generateTransId';

export const getCorrelationId = () => {
  let correlationId = sessionStorage.getItem('correlationId');
  if (!correlationId) {
    correlationId = generateTransId();
    sessionStorage.setItem('correlationId', correlationId);
  }
  return correlationId;
};

export default getCorrelationId;
